import { action, observable, makeObservable } from 'mobx';
import { gameGlobalStates } from '../core/constants/reelConstants';

class GameStore {
  odd = 0;

  hasAutoBet = false;

  oddsInfo = [];

  replayData = null;

  isReplayWatchAgain = false;

  spinResult = {};

  noWinMatrix = [];

  isSpinStart = false;

  isSpinButtonHold = false;

  gameInitialMatrix = [];

  isNeedGetBalance = false;

  isNeedSpinAction = false;

  gameGlobalState = gameGlobalStates.none;

  isReelsRotating = false;

  skipWin = false;

  isResponseReady = false;

  isSpinButtonBlocked = false;

  isForceStop = false;

  canStop = false;

  hasWin = false;

  winEnded = true;

  wildsOpened = true;

  constructor() {
    makeObservable(this, {
      odd: observable,
      skipWin: observable,
      hasAutoBet: observable,
      wildsOpened: observable,
      gameGlobalState: observable,
      isSpinButtonHold: observable,
      isReplayWatchAgain: observable,
      isSpinButtonBlocked: observable,
      isForceStop: observable,
      isResponseReady: observable,
      isReelsRotating: observable,
      hasWin: observable,
      canStop: observable,
      winEnded: observable,
      replayData: observable,
      noWinMatrix: observable,
      isSpinStart: observable,
      oddsInfo: observable.deep,
      spinResult: observable.deep,
      isNeedSpinAction: observable,
      isNeedGetBalance: observable,
      gameInitialMatrix: observable.deep,
      setOdd: action.bound,
      setIsForceStop: action.bound,
      setGameGlobalState: action.bound,
      setIsResponseReady: action.bound,
      setWildsOpened: action.bound,
      setHasWin: action.bound,
      setSkipWin: action.bound,
      setCanStop: action.bound,
      setWinEnded: action.bound,
      setIsReelsRotating: action.bound,
      setIsSpinButtonBlocked: action.bound,
      setOddsInfo: action.bound,
      setSpinResult: action.bound,
      setReplayData: action.bound,
      setIsSpinStart: action.bound,
      setNoWinMatrix: action.bound,
      setIsSpinButtonHold: action.bound,
      setIsNeedSpinAction: action.bound,
      setIsNeedGetBalance: action.bound,
      setGameInitialMatrix: action.bound,
      setIsReplayWatchAgain: action.bound,
    });
  }

  setReplayData(data) {
    this.replayData = data;
  }

  setHasAutoBet(bool) {
    this.hasAutoBet = bool;
  }

  setIsSpinButtonBlocked(bool) {
    this.isSpinButtonBlocked = bool;
  }

  setIsReplayWatchAgain(bool) {
    this.isReplayWatchAgain = bool;
  }

  setGameGlobalState(state) {
    this.gameGlobalState = state;
  }

  setWinEnded(bool) {
    this.winEnded = bool;
  }

  setHasWin(bool) {
    this.hasWin = bool;
  }

  setWildsOpened(bool) {
    this.wildsOpened = bool;
  }

  setIsReelsRotating(bool) {
    this.isReelsRotating = bool;
  }

  setCanStop(bool) {
    this.canStop = bool;
  }

  setSkipWin(bool) {
    this.skipWin = bool;
  }

  setIsResponseReady(bool) {
    this.isResponseReady = bool;
  }

  setIsForceStop(bool) {
    this.isForceStop = bool;
  }

  setIsNeedSpinAction(bool) {
    this.isNeedSpinAction = bool;
  }

  setIsNeedGetBalance(bool) {
    this.isNeedGetBalance = bool;
  }

  setNoWinMatrix(matrix) {
    this.noWinMatrix = matrix;
  }

  setOdd(value) {
    this.odd = value;
  }

  setSpinResult(spinResult) {
    this.spinResult = spinResult;
  }

  setGameInitialMatrix(matrix) {
    this.gameInitialMatrix = matrix;
  }

  setIsSpinButtonHold(bool) {
    this.isSpinButtonHold = bool;
  }

  setOddsInfo(oddsInfo) {
    this.oddsInfo = oddsInfo.reduce((acc, cur) => {
      acc.push(cur.reverse().filter((item) => !!item));
      return acc;
    }, []);
  }

  setIsSpinStart(bool) {
    this.isSpinStart = bool;
  }
}

export const gameStore = new GameStore();
